import axios from "axios";

const baseURL = process.env.REACT_APP_BACKEND_URL || "";

export const api = axios.create({ baseURL, timeout: 20000 });

export const apiGet = (url) => api.get(url).then((r) => r.data);
export const apiPost = (url, body) => api.post(url, body).then((r) => r.data);
